<!-- TODO: definire il testo -->
<app-toolkit-page-title title="Redazione"></app-toolkit-page-title>
<div class="row">
    <div class="col-sm-12">
        <p>Lorem ipsum dolor sit...</p>
    </div>
</div>